﻿/**
 * ui.message.js
 * @namespace
 */

/* SAMPLES:
//////////////////////////////////////////////////////////////////////////////////////////////
//Minimum usable sample:

    UI.message.show({
        header: 'header text',
        body: messageBodyDraw
    });

//////////////////////////////////////////////////////////////////////////////////////////////
//Fully configured sample:

    UI.message.show({

        //base message
        header:                 {STRING} || {FUNCTION} RETURNING {STRING}!
        body:                   {STRING} || {FUNCTION} RETURNING {STRING}!
        hasCloseBtn:            {BOOL}      -> show/hide "Close button"
        type:                   {STRING}    -> warning | notification | negative | positive -> default is 'notification', wrong type will display grey message
        className:              {STRING}
        offsetTop:              {NUMBER}    -> set the CSS "top" property of the popup window in "px"

        //callbacks
        beforeShowCallback:     {FUNCTION} -> anonymous || reference
        beforeHideCallback:     {FUNCTION} -> anonymous || reference
        afterShowCallback:      {FUNCTION} -> anonymous || reference
        afterHideCallback:      {FUNCTION} -> anonymous || reference

        //CTAs configuration
        actions: {
            close: {
                text:           {STRING}
                classes:        {STRING}
                context:        {OBJECT}
                focus:          {BOOL}
            },
            accept: {
                text:           {STRING}
                classes:        {STRING}
                context:        {OBJECT}
                focus:          {BOOL}
            },
            cancel: {
                text:           {STRING}
                classes:        {STRING}
                context:        {OBJECT}
                focus:          {BOOL}
            },
            confirm: {
                text:           {STRING}
                classes:        {STRING}
                context:        {OBJECT}
                focus:          {BOOL}
            },

            // ADD YOUR CUSTOM BUTTON
            myCustomBtn: {
                callback:       {FUNCTION} -> anonymous || reference
                text:           {STRING}
                classes:        {STRING}
                context:        {OBJECT}
                focus:          {BOOL}
            }
        }
    });

*/

var UI = window.UI || {};

/**
 * @returns public methods
 */

UI.CreatePopUp = function CreatePopUp(config, msgStackContainer, legacyCallback) {
    this.msgStackContainer = msgStackContainer || document.body;
    this.msgContainer = document.createElement("div");
    this.config = this.setConfig(config, legacyCallback);
}

UI.CreatePopUp.prototype.show = function() {
    this.msgStackContainer.appendChild(this.msgContainer);
    this.config.popupConfig.popupPortalEl = this.msgContainer;
    
    var msg =
        ReactDOM.render(
            React.createElement(sbRespUI.Popup, {
                config: this.config.popupConfig
            }, React.createElement(sbRespUI.PopupMessage, {
                config: this.config.popupMessageConfig
            })),
            this.msgContainer);      

    return msg;
}


UI.CreatePopUp.prototype.hide = function() {
    ReactDOM.unmountComponentAtNode(this.msgContainer);

    return this;
}

UI.CreatePopUp.prototype.setConfig = function(config, _legacyCallback) {
    var popupConfig = {},
        popupMessageConfig = {};
        var legacyCallback = _legacyCallback;

    if (config) {

        config.popupPortalEl && (popupConfig.popupPortalEl = config.popupPortalEl);
        config.wrapperClassname && (popupConfig.className = config.wrapperClassname);
        config.hasOverlay && (popupConfig.hasOverlay = config.hasOverlay);
        popupConfig.hasCloseBtn = config.crossBtn === false ? false : true;
        config.offsetTop && (popupConfig.offsetTop = config.offsetTop);
        config.isInIframe && (popupConfig.isInIframe = config.isInIframe);
        config.beforeShowCallback && (popupConfig.beforeShowCallback = config.beforeShowCallback);
        config.beforeHideCallback && (popupConfig.beforeHideCallback = config.beforeHideCallback);
        config.afterHideCallback && (popupConfig.afterHideCallback = config.afterHideCallback);
        config.afterShowCallback && (popupConfig.afterShowCallback = config.afterShowCallback);

        popupConfig.legacyCallback = legacyCallback;

        config.header && (popupMessageConfig.header = config.header);
        config.wrapperClassname && (popupMessageConfig.className = config.wrapperClassname);
        config.body && (popupMessageConfig.body = config.body);
        config.type && (popupMessageConfig.type = config.type);

        popupMessageConfig.actions = {};
        var ref = this;

        if (config.actions && Object.keys(config.actions).length > 0) {
            Object.keys(config.actions).forEach(function (key) {
                popupMessageConfig.actions[key] = {};
                switch (key) {
                    case "close":
                        popupMessageConfig.actions[key].classes = config.actions[key].classes ? config.actions[key].classes + " rj-popup-message__btn--negative" : "rj-popup-message__btn--negative";
                        break;

                    case "accept":
                    case "confirm":
                        popupMessageConfig.actions[key].classes = config.actions[key].classes ? config.actions[key].classes + " rj-popup-message__btn--positive" : "rj-popup-message__btn--positive";
                        break;

                    case "cancel":
                    default:
                        popupMessageConfig.actions[key].classes = config.actions[key].classes ? config.actions[key].classes + " rj-popup-message__btn--default" : "rj-popup-message__btn--default";
                        break;
                }
                popupMessageConfig.actions[key].text = config.actions[key].text;
                popupMessageConfig.actions[key].focus = config.actions[key].focus || false;
                popupMessageConfig.actions[key].onClick = config.actions[key].callback || ref.hide;
                popupMessageConfig.actions[key].context = config.actions[key].context || ref;
            })
        }
    }

    return { popupConfig: popupConfig, popupMessageConfig: popupMessageConfig };
}

UI.message = (function () {
    var popupStack = [];
    var msgStackContainer = null;
    
    function show(config,id) {                
        msgStackContainer = document.getElementById("rj-popup-message-root") || document.body;       
        
        var popupInfo = id ? popupStack.find(function(p){return p.id === id && typeof id === 'string'}) : undefined;

        if(!popupInfo)
        {
            var popup = new UI.CreatePopUp(config, msgStackContainer, this.removeFromStack.bind(this,id));
            popupStack.push({ id: id, popup: popup });
        }
        else
        { 
            var popup = popupInfo.popup;
        }

        popup.show();

        popupStack.forEach(function(p) { p.popup.msgContainer.classList.add("hidden")});
        popup.msgContainer.classList.remove("hidden");

        return popup;
    } 

    function hide(id) {        
        var popupInfo = id ? popupStack.find(function(p){return p.id === id && typeof id === 'string'}) : undefined;

        if(popupInfo)
        {   popupInfo.popup.hide();   }
        else if(typeof id === "undefined")
        {   popupStack.length > 0 && popupStack[popupStack.length-1].popup.hide();    }       

        return popupStack;
    }

    function removeFromStack(id) {        
        if(id && popupStack.length > 0)
        {
            var popupInfo = popupStack.find(function(p){return p.id === id && typeof id === 'string'});

            if(popupInfo)
            {
                var index = popupStack.map(function(x) {return x.id; }).indexOf(id);
                popupStack.splice(index, 1);
                popupStack.push(popupInfo);
            }
        }

        if (popupStack.length > 0) {         
            popupStack[popupStack.length-1].popup.msgStackContainer.removeChild(popupStack[popupStack.length-1].popup.msgContainer);
            popupStack.pop();
            popupStack.length > 0 && popupStack[popupStack.length-1].popup.msgContainer.classList.remove("hidden");
        }    

        return popupStack;
    }


    return {
        show: show,
        hide: hide,
        removeFromStack: removeFromStack,
        popupStack: popupStack
    };

}());

// override default alert function to use UI.message.show behavior

function alert(message) {
    'use strict';
    UI.message.show({
        body: message,
        actions: {
            accept: { text: "OK", focus: true },
        }
    });
}
Window.prototype.alert = window.alert = alert;

window.UI = UI;
